import { render, staticRenderFns } from "./HorizontalCardComingSoon.html?vue&type=template&id=13068979&scoped=true&"
import script from "./HorizontalCardComingSoon.vue?vue&type=script&lang=js&"
export * from "./HorizontalCardComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalCardComingSoon.scss?vue&type=style&index=0&id=13068979&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13068979",
  null
  
)

export default component.exports